<template>
    <section>
        <app-sales-table :Course_Type='CourseType' :Purchase_Type='PurchaseType' :Status='1'></app-sales-table>
    </section>
</template>
<script>
import appSalesTable from '../views/tables/SalesTable'
export default {
    components:{
        appSalesTable
    },
    data(){
        return {
            CourseType   : "Online",
            PurchaseType : 'Course'
        }
    },
    mounted(){
        this.$eventHub.$emit("LOADING",'false')
    }
}
</script>
<style scoped>

</style>